/**
 * baserCMS :  Based Website Development Project <https://basercms.net>
 * Copyright (c) NPO baser foundation <https://baserfoundation.org/>
 *
 * @copyright     Copyright (c) NPO baser foundation
 * @link          https://basercms.net baserCMS Project
 * @since         5.0.0
 * @license       https://basercms.net/license/index.html MIT License
 */

/**
 * baseUrl プラグイン
 */
(function( $ ){
    $.baseUrl = function() {
        return $("#AdminScript").attr('data-baseUrl');
    };
})( jQuery );


